import { useQuery } from '@apollo/client';
import getCurrentUserPortalUrls from './currentUserPortalUrls.graphql';

export const useCurrentUserPortalUrlsQuery = () => {
  return useQuery<CurrentUser>(getCurrentUserPortalUrls);
};
